'use client'

import type { Modal } from '@/contentful/generated/schemas'

import { MemcoModal } from './modal'

type MemcoModalInlineTriggerProps = {
  content: Modal
}

/**
 * Renders a Modal trigger as inline text (for use in richtext).
 * Shows the trigger button and opens the modal when clicked.
 * Returns null if the modal doesn't have a properly configured trigger.
 */
export function MemcoModalInlineTrigger({
  content,
}: MemcoModalInlineTriggerProps) {
  const triggerLink = content.fields?.trigger
  const triggerName = triggerLink?.fields?.name

  if (!triggerLink || !triggerName) return null

  return (
    <span className="mt-[28px] inline-block">
      <MemcoModal content={content} />
    </span>
  )
}
